import ReactDataGrid from "@inovua/reactdatagrid-community";

export default function CustomDataGrid({dataSource, ...otherProps}) {

    return <div style={{height: `${3.1 + dataSource.length * 2.854}em`}} className={"mb-3"}>

        <ReactDataGrid
            dataSource={dataSource}
            style={{minHeight: "100%"}}
            sortable={false}
            showZebraRows={false}
            showHoverRows={false}
            {...otherProps}
        />
    </div>;
}